import { useEffect, useState } from 'react'
import { getConsentStatus, resolveLegalLinks } from './consentService'
import type { ConsentLegal, LegalNotice } from './types'

/**
 * Terms and Privacy URLs for a notice line, and the Terms version they belong to. Renders the
 * platform fallbacks straight away and swaps in the published URLs once `getConsentStatus`
 * answers; on failure (including an old cloud without the function) the fallbacks simply stay
 * and the version stays null.
 *
 * A form that sends consent must take `termsVersion` from the same call that renders its notice,
 * so the version recorded is the one whose links the user was shown.
 */
export function useLegalLinks(platformUrl?: string | null): LegalNotice {
  const [legal, setLegal] = useState<ConsentLegal | null>(null)

  useEffect(() => {
    let cancelled = false
    getConsentStatus()
      .then((status) => {
        if (!cancelled) setLegal(status?.legal ?? null)
      })
      .catch((err) => {
        console.warn('[consent] Could not load the policy links; using the platform pages.', err)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { ...resolveLegalLinks(legal, platformUrl), termsVersion: legal?.termsVersion ?? null }
}
